import { Component, ElementRef, OnInit, Renderer, ViewEncapsulation,ViewChildren, QueryList, } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { HandleRequestService } from 'src/app/shared/services/handle-request.service';
import { APIResponse } from 'src/app/shared/models/api-response';
import { ActivatedRoute } from '@angular/router';
import { Student } from 'src/app/shared/models/student';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-runner5',
  templateUrl: './runner5.component.html',
  styleUrls: ['./runner5.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class Runner5Component implements OnInit {
  @ViewChildren('canvas') canvasElements: QueryList<ElementRef<HTMLCanvasElement>>;
  canvases = [
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
  ];

  
  resultData: any[] = [];
  student: Student;
  isIOS = false;

  defaultData = [
    ['1', '1', '4', '0', '2', '2', '0', '3', '3', '2', '2', '1', '0', '1', '5', '2', '1', '2', '5', '1',
      '0', '2', '2', '1', '0', '1', '3', '0', '0', '1', '3', '2', '2', '2', '2', '3', '1', '2', '3', '3',
    ], // 0
    ['1209', '1436', '1486', '795', '1700', '1372', '1049'], // 1
    ['690.36', '637.26', '814.77', '694.5', '220.37'], // 2
    ['3985', '2536', '2748', '6780', '3395', '576', '4079'], // 3
    [], // 4
    ['3906', '432', '1064', '3486', '9313', '22066', '7518', '57015'], // 5
    ['191', '208', '48', '58', '137', '26', '75', '32'], // 6
    [], // 7
    ['8', '36', '47', '81', '1', '69', '19', '79'], // 8
    ['92.89', '30.81', '21.89', '23.62', '60.47', '61.77', '1.77', '63.78', '88.78', '55.4', '23.16', '89.07', '6.31', '30.74'], // 9
    ['869', '0', '115', '310', '984', '477', '918'], // 10
    ['5922', '3336', '1220', '1625', '82305', '2061', '3055', '15575', '26084', '23655'], // 11
    ['7', '3', '6', '15', '32', '14', '6', '14', '5', '19'], // 12
    [], // 13
    [], // 14
    ['1938', '1593', '858', '596', '2054', '1230', '1714'], // 15
    ['893.66', '838.9', '883.44', '614.63', '1053.14', '616.49', '590.24', '842.82', '887.28', '685.45'], // 16
    ['2182', '3666', '3081', '2453', '6330', '2002', '6880'], // 17
    ['6720', '3080', '4416', '2632', '459', '616', '1272', '1710', '21783', '37224', '3144', '30690'], // 18
    ['68', '65', '68', '104', '79', '235', '69', '265', '3630', '295', '869', '395'], // 19
    ['88', '16', '21', '89', '47', '18', '43', '13'], // 20
    ['36.76', '46.03', '97.09', '37.33', '86.56', '18.32', '10.18', '26.47', '53.3', '32.77', '67.1', '72.05', '70.99', '72.17'], // 21
    ['538', '728', '56', '578', '929', '752', '912'], // 22
    ['1344', '7608', '615', '9135', '32325', '1984', '5106', '33444', '8865', '19106'], // 23
    ['8', '8', '6', '3', '9', '9', '7', '9', '4', '6'], // 24
    [], // 25
    [], // 26
    [], // 27
    [], // 28
    ['2034', '1299', '1358', '596', '2156', '1140', '1714'], // 29
    ['268.81', '608.03', '824.01', '244.67', '194.51', '905.67', '591.55', '296.83', '547.22', '911.29'], // 30
    ['4684', '5599', '4789', '2016', '4699', '5896', '4490'], // 31
    ['1482', '5978', '1190', '2816', '754', '3648', '1065', '1495', '7728', '35226', '43604', '35066'], // 32
    ['374', '557', '4762', '487', '965', '572', '568', '436', '7', '4', '25', '3'], // 33
    ['98', '83', '65', '45', '90', '71', '84', '61'], // 34
    ['86.5', '64.6', '40.96', '80.36', '12.59', '65.67', '47.75', '4.95', '21.21', '20.11', '60.48', '85.48', '40.98', '99.05'], // 35
    ['931', '604', '345', '119', '463', '927'], // 36
    ['936', '1320', '2512', '25705', '65880', '4725', '2928', '53515', '57090', '12348'], // 37
    ['25', '21', '8', '7', '8', '9', '48', '9', '8', '21'], // 38
    [], // 39
    [], // 40
    [], // 41
    ['9', '4', '7', '2', '3', '5', '6', '8', '1'], // 42
    ['640', '1923', '1520', '1828', '797', '1872', '1400'], // 43
    ['347.1', '729.1', '781.27', '570.86', '616.1', '847.88', '366.26', '792.59', '267.28', '605.12'], // 44
    ['3050', '4732', '5807', '5702', '3286', '7032', '3932'], // 45
    ['7387', '392', '5264', '5605', '2418', '7821', '2156', '1800', '22223', '18207', '36651', '75998'], // 46
    ['617', '573', '587', '586', '298', '958', '963', '584', '8', '28', '7', '7'], // 47
    ['53', '41', '8', '61', '48', '70', '2', '4'], // 48
    ['72.25', '59.6', '17.52', '85.41', '80.89', '43.15', '5.79', '6.14', '57.47', '51.87', '8.64', '8.31', '44.94', '1.21'], // 49
    ['17', '517', '957', '880', '314', '163', '311'], // 50
    ['2655', '4494', '1320', '10772', '61173', '7816', '648', '48075', '28756', '53322'], // 51
    ['25', '262', '52', '96', '28', '58', '147', '49', '73', '19'], // 52
    [], // 53
    [], // 54
    [], // 55
    ['2', '9', '8', '3', '4', '11', '4', '4', '10', '5', '4', '5'], // 56
    ['2217', '1554', '1927', '1765', '1127', '1417'], // 57
    ['878.14', '975.57', '248.61', '59.69', '409.71', '845.81', '833.89', '786.88', '559.7', '1032.17'], // 58
    ['1449', '11238', '10329', '4969', '5165', '6299', '4718'], // 59
    ['5220', '2788', '2184', '16226', '53925', '8030', '10692', '25432', '1320', '2655', '5248', '40870'], // 60
    ['492', '358', '633', '8', '32', '42', '3', '6', '759', '4683', '656', '7'], // 61
    ['34', '12', '46', '71', '4', '92', '18', '38'], // 62
    ['11.23', '41.06', '48.09', '4.51', '2.96', '84.09', '89.2', '32.74', '42.54', '12.46', '8.65', '46.35', '88.92', '30.44'], // 63
    ['103', '81', '662', '119', '241', '533', '167'], // 64
    ['3884', '566', '2844', '12567', '9924', '3845', '952', '32336', '11360', '37737'], // 65
    ['39', '62', '38', '59', '139', '48', '412', '67', '84', '97'], // 66
    [], // 67
    [], // 68
    [], // 69
    ['3927', '3786', '1795', '1184', '847', '1144', '491', '457', '410', '283', '249', '141', '613'], // 70
    ['1266', '336', '1059', '1458', '1551', '1059', '1262'], // 71
    ['562.8', '408.82', '378.89', '871.11', '759.6', '141.23', '392.89', '269', '398.08', '825.49'], // 72
    ['3580', '17145', '1523', '2303', '6038', '4592', '8699'], // 73
    ['1848', '1386', '3534', '390', '840', '1464', '1586', '2304', '5635', '22432', '12172', '5440'], // 74
    ['6', '6', '8', '4', '6', '24', '7', '16', '9', '68', '7', '16'], // 75
    ['78', '20', '24', '67', '25', '96', '87', '79'], // 76
    ['30.64', '9.92', '7.19', '18.38', '78.72', '97.73', '6.06', '99.98', '41.53', '68.97', '50.43', '93.08', '71.68', '2.28'], // 77
    ['231', '948', '63', '7', '188', '647', '637'], // 78
    ['4044', '2493', '2828', '1547', '1208', '24616', '12110', '26712', '11120', '4492'], // 79
    ['132', '65', '39', '536', '751', '244', '53', '4313', '356', '843'], // 80
    [], // 81
    [], // 82
    [], // 83
    ['22', '15', '22', '20', '12', '25', '25', '32', '18', '32'], // 84
    ['1725', '1516', '1398', '1178', '1164', '1723', '1720'], // 85
    ['317.66', '574.04', '580.62', '656.09', '600.96', '596.31', '886.5', '713.11', '475.85', '917.19'], // 86
    ['3838', '4063', '5000', '2498', '9690', '5918', '5076'], // 87
    ['6365', '492', '5382', '3999', '8544', '6912', '2516', '1674', '22890', '9731', '7056', '15344'], // 88
    ['52', '21', '8', '63', '3', '16', '26', '3', '12', '36', '8', '8'], // 89
    ['58', '6', '88', '4', '41', '13', '27', '88'], // 90
    ['108.81', '43.02', '34.3', '68.06', '42.05', '15.34', '46.01', '47.42', '76.62', '88.6', '63.64', '8.28', '45.82', '86.22'], // 91
    ['819', '515', '250', '976', '0', '939', '319'], // 92
    ['847', '5392', '1431', '1074', '1860', '17106', '23100', '16950', '9171', '4200'], // 93
    ['94', '75', '65', '166', '476', '572', '464', '349', '669', '883'], // 94
    [], // 95
    [], // 96
    [], // 97
    [], // 98
    ['1209', '1172', '1033', '1052', '1378', '1212', '945'], // 99
    ['770.59', '246.76', '449.81', '173.02', '530.41', '357.13', '362.24', '423.94', '282.66', '950.14'], // 100
    ['3019', '4535', '4916', '4175', '5854', '1030', '5769'], // 101
    ['8148', '1598', '2156', '481', '1323', '270', '69552', '2300', '7056', '23746', '4140', '45612'], // 102
    ['3', '8', '29', '4', '9', '36', '68', '57', '46', '67'], // 103
    ['74', '94', '89', '46', '76', '61', '78', '85'], // 104
    ['94.12', '12.09', '85.64', '67.87', '5.53', '73.89', '12.85', '24.79', '3.71', '31.52', '6.83', '10.23', '37.07', '75.88'], // 105
    ['126', '883', '630', '282', '693', '724', '891'], // 106
    ['1330', '3652', '1196', '2537', '32655', '13536', '1464', '5139', '4465', '5264', '24944', '5996'], // 107
    ['68', '163', '67', '1557', '524', '954', '316', '281', '119', '2119', '3199', '1058'], // 108
    [], // 109
    [], // 110
    [], // 111
    [
      '0', '0', '0', '0', '0', '1', '1', '1', '1', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '1', '1', '1', '0',
      '0', '0', '0', '0', '0', '0', '1', '1', '1', '1', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '1', '1', '1', '1', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '1', '1', '1',
      '1', '1', '1', '1', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '1', '1', '1', '1', '0', '0', '0',
    ], // 112
    ['1041', '1252', '1107', '1245', '1242', '1368', '1000'], // 113
    ['573.57', '906.84', '346.04', '351.5', '719.44', '353.88', '529.62', '394.41', '591.92', '304.91'], // 114
    ['4744', '14072', '3655', '6410', '6827', '4401', '3111'], // 115
    ['735', '2375', '8178', '4693', '4644', '19250', '1458', '3120', '15536', '16473', '9882', '25230'], // 116
    ['13', '8', '34', '9', '38', '6', '7', '7', '69', '198', '49', '68'], // 117
    ['82', '83', '45', '14', '8', '4', '72', '29'], // 118
    ['42.9', '53.98', '8.58', '7.94', '30.28', '74.75', '63.79', '87.29', '56.8', '33.1', '53.2', '67.03', '18.2', '73.94'], // 119
    ['592', '683', '299', '676', '409', '201', '65'], // 120
    ['6750', '1072', '798', '2480', '6950', '14462', '3906', '1897', '6916', '2136', '37194', '26271'], // 121
    ['98', '285', '94', '269', '358', '2945', '96', '149', '168', '594', '649', '473'], // 122
    [], // 123
    [], // 124
    [], // 125
    [], // 126
    ['1045', '782', '1018', '1407', '965', '1146', '1248'], // 127
    ['494.53', '848.48', '568.56', '406.35', '942.1', '8.19', '509.24', '796.69', '88.54', '748.06'], // 128
    ['4088', '1206', '4281', '2029', '5884', '5425', '4680'], // 129
    ['4599', '462', '3519', '18125', '38520', '14080', '1739', '2214', '24978', '13617', '18180', '35061'], // 130
    ['6', '45', '8', '26', '65', '9', '124', '123', '93', '56', '41', '89'], // 131
    ['22', '76', '6', '99', '11', '39', '76', '64'], // 132
    ['39.29', '88.36', '99.45', '27.74', '93.31', '6.67', '23.41', '31.59', '68.41', '84.05', '56.85', '64.55', '82.28', '97.22'], // 133
    ['45', '191', '658', '348', '257', '758', '394'], // 134
    ['686', '5166', '4233', '319', '33225', '38655', '820', '846', '1848', '1110', '4052', '24984'], // 135
    ['69', '123', '63', '3546', '607', '853', '248', '99', '24', '1083', '961', '898'], // 136
    [], // 137
    [], // 138
    [], // 139
    ['578', '1212', '1047', '649', '1184', '372', '701.43', '881.27', '202.54', '244.54'], // 140
    ['2047', '1215', '2584', '2345', '1652', '8544', '2262', '2814', '1425', '3128'], // 141
    ['444', '517', '987', '463', '918', '62', '56', '78', '51', '43'], // 142
    [], // 143
    [], // 144
    [], // 145
    ['33', '59', '88', '97', '23', '85', '376', '505', '544', '971', '2627', '520'], // 146
    ['4044', '2493', '5658', '22316', '39245', '5142', '30220', '14560', '3420', '2856',
      '945', '3888', '58', '67', '74', '595', '348', '1739', '981', '1638'], // 147
  ];
  type = 'runner5';

  constructor(
    private utilService: UtilService,
    private httpService: HandleRequestService,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private toastr: ToastrService,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) {
      this.isIOS = true;
    }

    for (var i = 0; i < 148; i++) {
      this.resultData.push({
        values: [],
        times: '',
        count: 0,
        correctAnswers: 10,
        resultIsIncorrect: [false,false,false,false,false,false,false,false,false,false],
        finished: false
      })
    }
    
    this.route.data.subscribe(x => {
      if (x.hasOwnProperty('profile')) {
        const response = x.profile as APIResponse;
        this.student = response.data as Student;
      }

      this.httpService.post('/smartpdf/get', {
        type: this.type,
        user_id: this.student._id,
      }).then(
        (res: APIResponse) => {
          if (res.data.smartpdf) {
            this.resultData = res.data.smartpdf.data.result;
          }
          this.canvases.forEach((canvas, index) => {
            if (!canvas.context) {
              canvas.context = this.canvasElements.toArray()[index].nativeElement.getContext('2d');
            }
          });
          this.loadDrawing();
        }, () => {
         
        }
      );
      
    });
  }

  startDrawing(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  startDrawing1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing1(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  saveDrawing(index: number): void {
    this.toastr.info('Saving...');
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const dataURL = canvasElement.toDataURL();
    this.httpService.post('/smartcanvas/update', {
      type: this.type,
      user_id: this.student._id,
      serial: index,
      data: dataURL
    }).then(
      (res: APIResponse) => {
        this.toastr.clear();
        this.toastr.success('Successfully Saved');
      }, () => {
      }
    );
  }

  async loadDrawing() {
    for (var index in this.canvases) {
      this.httpService.post('/smartcanvas/get', {
        type: this.type,
        user_id: this.student._id,
        serial: index
      }).then(
        (res: APIResponse) => {
          if (res.data.smartcanvas) {
            const img = new Image();
            img.onload = () => {
            const canvasElement = this.canvasElements.toArray()[index].nativeElement;
              const context = canvasElement.getContext('2d');
              context.clearRect(0, 0, canvasElement.width, canvasElement.height);
              context.drawImage(img, 0, 0);
            };
            img.src = res.data.smartcanvas.data;
          }
        }, () => {
         
        }
      );

      await this.delay(2000);
    }
    
  }

  backToSavedImage(index: number) {
    this.httpService.post('/smartcanvas/get', {
      type: this.type,
      user_id: this.student._id,
      serial: index
    }).then(
      (res: APIResponse) => {
        if (res.data.smartcanvas) {
          const img = new Image();
          img.onload = () => {
          const canvasElement = this.canvasElements.toArray()[index].nativeElement;
            const context = canvasElement.getContext('2d');
            context.clearRect(0, 0, canvasElement.width, canvasElement.height);
            context.drawImage(img, 0, 0);
          };
          img.src = res.data.smartcanvas.data;
        }
      }, () => {
       
      }
    );
  }

  clearCanvas(index: number): void {
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const context = canvasElement.getContext('2d');
    context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  }

  canvasPropertiesChanges(): void {
    this.canvases.forEach(canvas => {
      if (!canvas.isEraser) {
        canvas.context.strokeStyle = canvas.brushColor;
      }
      canvas.context.lineWidth = canvas.brushSize;
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  quastionConfirm(index) {
    this.resultData[index].finished = true;
    if (this.resultData[index].count < 2) {
      this.resultData[index].count++;
      let allCorrect = true;
      for (let i in this.defaultData[index]) {
        if (this.defaultData[index][i] != this.resultData[index].values[i]) {
          allCorrect = false;
        }
      }
      if (!allCorrect && this.resultData[index].count == 1) {
        this.toastr.error('Corrige el resultado en rojo y vuelve a picar. Solo tienes una oportunidad de corregir.');
      }
    }
    this.saveData();
  }

  quastionChange(index) {
    this.resultData[index].finished = false;
  }

  clickedNumbers(i, j) {
    if (this.resultData[i].finished && this.resultData[i].count >= 2) {
      return;
    }
    this.resultData[i].finished = false;
    if (this.resultData[i].values[j] == '1') {
      this.resultData[i].values[j] = '0';
    } else {
      this.resultData[i].values[j] = '1';
    }
  }

  quastionConfirm1(index) {
    this.resultData[index].finished = true;
    this.saveData();
  }

  correctAnswerCheck(i, j) {
    if (!this.resultData[i].resultIsIncorrect[j] && this.resultData[i].finished){
      if (document.activeElement && document.activeElement !== document.body) {
        this.renderer.invokeElementMethod(
          this.elRef.nativeElement.ownerDocument.activeElement, 'blur');
      }
      this.resultData[i].resultIsIncorrect[j] = true;
      this.resultData[i].correctAnswers--;
      this.saveData();
    }
  }

  saveData() {
    this.toastr.info('Saving...');
    this.httpService.post('/smartpdf/update', {
      type: this.type,
      user_id: this.student._id,
      data: {
        result: this.resultData
      }
    }).then(
      (res: APIResponse) => {
        this.toastr.success('Saved');
      }, () => {
      }
    );
  }
}
